export default [
  {
    id: '6094d1232484deb6cdcce453',
    createdOn: '2022-10-13T11:55:57.345Z',
    title: 'Multiple Players, Multiple Entries',
    description:
      'A contest involving more than 2 players with multiple entries per player and the winnings sharing is specified in the contest model',
    slug: 'multiple_player_multiple_entry',
    acceptsMultipleEntry: true,
    requireValidationChecks: true
  },
  {
    id: '6094d1232484deb6cdcce452',
    createdOn: '2022-10-13T11:55:57.345Z',
    title: 'Multiple Players, One Entry',
    description:
      'A contest involving more than 2 players with one entry per player and the winnings sharing is specified in the contest model',
    slug: 'multiple_player_one_entry',
    acceptsMultipleEntry: false,
    requireValidationChecks: true
  },
  {
    id: '6094d1232484deb6cdcce451',
    createdOn: '2022-10-13T11:55:57.345Z',
    title: 'Head to Head',
    description: 'A contest involving 2 people where the winner takes all',
    slug: 'head_to_head',
    acceptsMultipleEntry: false,
    requireValidationChecks: true
  },
  {
    id: '5fd31017dedfcb06b5cd21d2',
    createdOn: '2021-05-07T04:45:05.080Z',
    title: 'Multiple Players1, One Entry',
    description:
      'A contest involving more than 2 players with one entry per player and the winnings sharing is specified in the contest model',
    slug: 'multiple_player_one_entry',
    acceptsMultipleEntry: false,
    requireValidationChecks: true
  },
  {
    id: '5fd31017dedfcb06b5cd21d1',
    createdOn: '2021-05-07T04:45:05.080Z',
    title: 'Head1 to Head',
    description: 'A contest involving 2 people where the winner takes all',
    slug: 'head_to_head',
    acceptsMultipleEntry: false,
    requireValidationChecks: true
  },
  {
    id: '5fd31017dedfcb06b5cd21d4',
    createdOn: '2021-05-07T04:45:05.080Z',
    title: 'Multiple Players1, Multiple Entries',
    description:
      'A contest involving more than 2 players with multiple entries per player and the winnings sharing is specified in the contest model',
    slug: 'multiple_player_multiple_entry',
    acceptsMultipleEntry: true,
    requireValidationChecks: true
  }
];
